var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrystalsSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 189,
    viewBox: "0 0 188 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 94.5,
    r: 92,
    fill: "white",
    stroke: "#34D399",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.136 41.4919L150.051 40.2126C149.068 39.1843 147.705 38.6025 146.28 38.6025H118.698C117.273 38.6025 115.91 39.1843 114.927 40.2126V41.4919L122.052 53.1739H144.063L150.136 41.4919Z",
    fill: "#6366F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.698 38.6025C117.273 38.6025 115.91 39.1843 114.927 40.2126V41.4919L118.508 47.3642L124.679 38.6025H118.698Z",
    fill: "#6366F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.489 38.6025L122.577 53.1739L123.194 53.7739H141.402L142.401 53.1739L132.489 38.6025Z",
    fill: "#6366F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.927 40.2129L105.025 50.5689C104.353 51.2714 103.979 52.2042 103.979 53.1743L104.634 53.7739H121.543L122.576 53.1743L114.927 40.2129Z",
    fill: "#6366F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.417 53.1733L118.856 46.8696L114.927 40.2119L105.025 50.568C104.353 51.2704 103.979 52.2033 103.979 53.1733L104.634 53.7729H114.729L114.417 53.1733Z",
    fill: "#6366F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161 53.1733C161 52.2033 160.625 51.2704 159.953 50.568L150.051 40.2119L142.401 53.1733L143.162 53.7729H160.5L161 53.1733Z",
    fill: "#6366F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.979 53.1738C103.979 54.2626 104.368 55.3159 105.078 56.1439L128.425 83.4012C129.441 84.5862 130.926 85.2685 132.489 85.2685C134.053 85.2685 135.538 84.5862 136.553 83.4012L159.901 56.1439C160.61 55.3156 161 54.2626 161 53.1738H103.979Z",
    fill: "#6366F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.417 53.1738H103.979C103.979 54.2626 104.368 55.3159 105.078 56.1439L128.426 83.4012C129.115 84.2062 130.022 84.7783 131.022 85.0632L114.417 53.1738Z",
    fill: "#6366F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.489 85.2688C132.991 85.2688 133.484 85.1978 133.956 85.0632L142.401 53.1738H122.577L131.022 85.0632C131.494 85.1978 131.987 85.2688 132.489 85.2688Z",
    fill: "#6366F1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M101.715 66.3139L100.967 64.1223C98.7701 62.7869 96.1202 62.4067 93.6347 63.0703L45.5318 75.9134C43.046 76.5769 40.942 78.2263 39.71 80.4774L40.31 82.7087L58.215 99.7644L96.6023 89.5152L101.715 66.3139Z",
    fill: "#6366F1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5318 75.9138C43.046 76.5774 40.942 78.2268 39.71 80.4778L40.31 82.7092L49.3104 91.2825L55.9624 73.1289L45.5318 75.9138Z",
    fill: "#6366F1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5833 69.4922L59.1299 99.5203L60.4888 100.279L92.2422 91.8008L93.7039 90.2894L69.5833 69.4922Z",
    fill: "#6366F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7095 80.4766L27.2969 103.148C26.455 104.686 26.2392 106.487 26.6942 108.179L28.1182 108.92L57.6092 101.046L59.1297 99.519L39.7095 80.4766Z",
    fill: "#6366F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8991 103.319L49.6849 90.2588L39.7095 80.4775L27.2969 103.149C26.455 104.687 26.2392 106.488 26.6942 108.18L28.1182 108.921L45.7252 104.22L44.8991 103.319Z",
    fill: "#6366F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.139 81.6286C125.684 79.9368 124.593 78.4846 123.093 77.5723L100.967 64.1221L93.7036 90.2887L95.3112 90.9806L125.549 82.9073L126.139 81.6286Z",
    fill: "#6366F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6938 108.18C27.2044 110.079 28.3781 111.734 30.0036 112.849L83.5054 149.514C85.8315 151.108 88.7413 151.606 91.4679 150.878C94.1947 150.15 96.4646 148.269 97.6791 145.729L125.615 87.3209C126.464 85.5461 126.649 83.5279 126.139 81.6289L26.6938 108.18Z",
    fill: "#6366F1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8988 103.32L26.6938 108.181C27.2044 110.079 28.3781 111.735 30.0036 112.849L83.5054 149.514C85.0853 150.597 86.9345 151.172 88.8129 151.204L44.8988 103.32Z",
    fill: "#6366F1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4686 150.878C92.3433 150.645 93.1703 150.291 93.9311 149.837L93.7039 90.2891L59.1299 99.5203L88.8134 151.203C89.7003 151.218 90.5937 151.112 91.4686 150.878Z",
    fill: "#6366F1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.386 43.2949L147.313 42.1953C146.469 41.3115 145.297 40.8115 144.072 40.8115H120.366C119.141 40.8115 117.969 41.3115 117.125 42.1953V43.2949L123.249 53.3354H142.167L147.386 43.2949Z",
    fill: "#C3DDFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.366 40.8115C119.141 40.8115 117.969 41.3115 117.125 42.1953V43.2949L120.203 48.342L125.506 40.8115H120.366Z",
    fill: "#A4CCFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M132.219 40.8115L123.699 53.3354L124.23 53.8511H139.879L140.738 53.3354L132.219 40.8115Z",
    fill: "#DBEAFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.124 42.1953L108.614 51.0962C108.036 51.6999 107.714 52.5017 107.714 53.3354L108.277 53.8508H122.811L123.699 53.3354L117.124 42.1953Z",
    fill: "#DBEAFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.686 53.3354L120.502 47.9175L117.124 42.1953L108.614 51.0962C108.036 51.6999 107.714 52.5017 107.714 53.3354L108.277 53.8508H116.955L116.686 53.3354Z",
    fill: "#C3DDFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M156.723 53.3354C156.723 52.5017 156.401 51.6999 155.824 51.0962L147.313 42.1953L140.738 53.3354L141.392 53.8508H156.294L156.723 53.3354Z",
    fill: "#DBEAFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M107.714 53.3359C107.714 54.2717 108.049 55.177 108.659 55.8887L128.726 79.3159C129.599 80.3345 130.875 80.9209 132.219 80.9209C133.563 80.9209 134.839 80.3345 135.712 79.3159L155.779 55.8887C156.388 55.1768 156.723 54.2717 156.723 53.3359H107.714Z",
    fill: "#A4CCFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M116.686 53.3359H107.714C107.714 54.2717 108.049 55.177 108.659 55.8887L128.726 79.3159C129.319 80.0078 130.098 80.4995 130.958 80.7444L116.686 53.3359Z",
    fill: "#8BB3EA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M132.219 80.9211C132.65 80.9211 133.074 80.8601 133.48 80.7444L140.738 53.3359H123.699L130.957 80.7444C131.364 80.8601 131.788 80.9211 132.219 80.9211Z",
    fill: "#C3DDFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2799 70.4765L98.6039 68.4961C96.6188 67.2893 94.2243 66.9458 91.9783 67.5454L48.5099 79.1511C46.2637 79.7507 44.3624 81.2412 43.249 83.2754L43.7912 85.2917L59.9712 100.704L94.6599 91.4424L99.2799 70.4765Z",
    fill: "#C3DDFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5099 79.1514C46.2637 79.751 44.3624 81.2415 43.249 83.2756L43.7912 85.292L51.9245 93.0393L57.9356 76.6348L48.5099 79.1514Z",
    fill: "#A4CCFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2436 73.3486L60.7974 100.484L62.0254 101.169L90.7194 93.5078L92.0402 92.1421L70.2436 73.3486Z",
    fill: "#DBEAFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2485 83.2754L32.0318 103.763C31.271 105.152 31.076 106.78 31.4871 108.309L32.7739 108.978L59.4235 101.863L60.7976 100.483L43.2485 83.2754Z",
    fill: "#DBEAFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M47.938 103.917L52.2628 92.1143L43.2485 83.2754L32.0318 103.763C31.271 105.152 31.076 106.78 31.4871 108.309L32.7739 108.978L48.6846 104.73L47.938 103.917Z",
    fill: "#C3DDFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M121.351 84.3159C120.94 82.7871 119.954 81.4749 118.598 80.6504L98.6037 68.4961L92.0405 92.1416L93.4932 92.7668L120.817 85.4714L121.351 84.3159Z",
    fill: "#DBEAFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4868 108.309C31.9482 110.024 33.0088 111.52 34.4777 112.527L82.8247 145.66C84.9267 147.1 87.5561 147.551 90.02 146.893C92.4841 146.235 94.5354 144.535 95.6328 142.24L120.877 89.459C121.644 87.8552 121.812 86.0315 121.35 84.3154L31.4868 108.309Z",
    fill: "#A4CCFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9377 103.917L31.4868 108.309C31.9482 110.025 33.0088 111.521 34.4777 112.528L82.8247 145.66C84.2524 146.638 85.9234 147.159 87.6208 147.187L47.9377 103.917Z",
    fill: "#8BB3EA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0203 146.893C90.8108 146.682 91.558 146.363 92.2456 145.952L92.0402 92.1416L60.7974 100.483L87.6209 147.187C88.4224 147.2 89.2297 147.104 90.0203 146.893Z",
    fill: "#C3DDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrystalsSuccess);
export default __webpack_public_path__ + "static/media/crystals_success.7ce45784afe689bbd6f292c6928aabbf.svg";
export { ForwardRef as ReactComponent };